import React, { Component } from "react";

interface Props<T> {
	id?: string;
	title?: string;
	items: T[];
	renderListHeader: () => React.ReactElement;
	renderListItem: ( item: T, index: number ) => React.ReactElement;
	isSearchable: boolean;
}

class ListDataView<T> extends Component<Props<T>> {
	static defaultProps: Partial<Props<any>> = {
		isSearchable: true,
	};

	render() {
		const { id, title, items, renderListHeader, renderListItem, isSearchable } = this.props;
		return <div className={ "table-box " + ( isSearchable ? "mb-3" : "hide-ui-toolbar" ) }>
			{ title && <div className="table-title hide">{ title }</div> }
			<table
				id={ id ? id : "ListView" }
                className="table table-borderless table-condensed table-striped table-responsive-sm dataTable">
				<thead>
				{ renderListHeader() }
				</thead>
				<tbody>
				{ items.map( ( item: T, index: number ) => {
					return renderListItem( item, index );
				} ) }
				</tbody>
			</table>
		</div>;
	}
}

export default ListDataView;
